/**
 * 가격을 10원 단위로 올림 처리합니다.
 * @param price 올림할 가격
 * @returns 10원 단위로 올림된 가격 (예: 5625 → 5630, 4049 → 4050)
 */
export const roundUpToTen = (price: number): number => {
  return Math.ceil(price / 10) * 10;
};

/**
 * 가격 대비 할인율을 계산합니다.
 * @param price 원래 가격
 * @param userPrice 할인된 가격
 * @returns 소수점 이하 버린 할인율 문자열 (예: "10")
 */
export function calculateDiscountRate(price: number, userPrice: number): string {
  if (price <= 0) {
    throw new Error("원래 가격은 0보다 커야 합니다.");
  }

  const discountRate = ((price - userPrice) / price) * 100;
  return discountRate.toFixed(0); // 소수점 둘째 자리까지 반환
}

/**
 * 가격을 100원 단위로 올림 처리합니다.
 * @param price 올림할 가격
 * @returns 100원 단위로 올림된 가격 (예: 5625 → 5700, 4049 → 4100)
 */
export const roundUpToHundred = (price: number): number => {
  return Math.ceil(price / 100) * 100;
};
